import {
  Backdrop,
  Box,
  Button,
  ButtonBase,
  Container,
  Grid,
  IconButton,
  Modal,
  Typography
} from "@mui/material";

import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router";
import { handlePagingAll } from "../../components/api/APIUtilities";
import ModalLoadingFull from "../../components/modals/ModalLoadingFull";
import { postNotification } from "../../components/utilities/Notifications";
import CountdownTimer from "../../components/utilities/CountdownTimer";

import Subscription from "../subscription/Subscription";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import moment from "moment";
import "moment-timezone";
import { globalVariables } from "../../global/GlobalVariables";
import { BCPXmark } from "../../components/icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { setCookie } from "../../components/layout/cookies/CookieFunctions";

const affiliateCodes = {
  TACOMA25: {
    expires: "2025-08-31",
    eventIds: [
      "8r0WoulZ8iZm", // 40k
      "l04ERVSoioI6", // AoS
      "6pT0RNGqDv9f", // KT
      "54f56hmLGFmF", // UW
      "eUJEIVR9aJwl", // AoS Doubles
      "0g9Vadok2RAA" // KT Doubles
    ],
    label: "2025 Warhammer Open - Tacoma Sale"
    // eventStreams: {
    //   eEZjjwXujh: [
    //     {
    //       label: "FLGN Youtube Broadcast",
    //       url: "https://www.youtube.com/@FrontlineGamingNetwork"
    //     },
    //     {
    //       label: "Wargames Live Second Table",
    //       url: "https://www.youtube.com/@WarGamesLive"
    //     },
    //     {
    //       label: "Spanish Language Coverage",
    //       url: "https://www.twitch.tv/deepgamesspain"
    //     },
    //     {
    //       label: "French Language Coverage",
    //       url: "https://www.twitch.tv/lawargameroom"
    //     }
    //   ],
    //   GYoZGtzElR: [
    //     {
    //       label: "Warhammer TV Stream",
    //       url: "https://www.twitch.tv/warhammer"
    //     }
    //   ],
    //   "1NXJNL5SwE": [
    //     {
    //       label: "Twitch Stream",
    //       url: "https://www.twitch.tv/lustersworkshop"
    //     }
    //   ]
    // }
  },
  wtc2023: {
    expires: "2023-08-31",
    eventIds: ["7CA6VVLL6P", "HDxMwXLMOy"],
    label: "WORLD TEAM CHAMPIONSHIP 2023",
    imageUrl:
      "https://d2h6r0nkvj3ft8.cloudfront.net/2023-07-23/XDF2-2GM9-5B3T.png"
  },
  NoHeroes: {
    label: "No Heroes",
    imageUrl: `${getEnvironmentVariable(
      "SYSTEM_IMAGES_CLOUDFRONT"
    )}/images/affiliates/NoHeroes.png`
  },
  tabletoptitans: {
    label: "Tabletop Titans",
    imageUrl: "https://www.tabletoptitans.tv/cdn/shop/files/Group_31.png"
  },
  titans: {
    label: "Tabletop Titans",
    imageUrl: "https://www.tabletoptitans.tv/cdn/shop/files/Group_31.png"
  }
};
export default function AffiliateLanding(props) {
  const { affiliate } = props;
  const authContext = useContext(AuthContext);
  const globalVars = globalVariables();
  const eventIds = props.eventIds || affiliateCodes[affiliate]?.eventIds || [];
  const label =
    props.label ||
    affiliateCodes[affiliate]?.label ||
    `Affiliate Landing: ${affiliate}`;
  const imageUrl = props.imageUrl || affiliateCodes[affiliate]?.imageUrl;
  const [loading, setLoading] = useState(true);
  const [events, setEvents] = useState(null);
  const [open, setOpen] = useState(false);
  const [expiry, setExpiry] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const loadpage = async () => {
      try {
        if (affiliateCodes[affiliate]?.expires) {
          let mExpiry = moment(affiliateCodes[affiliate]?.expires);
          setExpiry(mExpiry);
          if (mExpiry.isBefore()) {
            window.location.assign(`/subscription`);
            return;
          }
        }
        if (eventIds?.length > 0) {
          const queryStringParameters = {
            limit: 100,
            ended: false,
            "eventIds[]": eventIds,
            "expand[]": ["gameSystem", "photoFile"]
          };
          var apiEvents = await handlePagingAll(
            "/events",
            queryStringParameters
          );
          setEvents(apiEvents);
        }

        if (!authContext?.authState?.identity?.subscriber) {
          setOpen(true);
        }
      } catch (err) {
        postNotification("error", err);
        navigate("/");
        return;
      }

      setLoading(false);
    };
    loadpage();
    // eslint-disable-next-line
  }, [affiliate]);

  useEffect(() => {
    const setCookies = async () => {
      try {
        if (authContext?.authState?.cookieConsent) {
          if (affiliate) {
            setCookie("affiliate", affiliate);
          }
        }
      } catch (err) {}
    };
    setCookies();
    // eslint-disable-next-line
  }, [authContext]);
  return (
    <>
      {loading && <ModalLoadingFull />}
      {!loading && (
        <Box sx={{ width: "100%" }}>
          <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
            <Grid container sx={{ gap: 2 }}>
              {imageUrl && (
                <Grid item xs={12} textAlign="center">
                  <img
                    src={imageUrl}
                    alt={label}
                    style={{
                      maxHeight: "250px"
                    }}
                  />
                </Grid>
              )}
              {label && (
                <Grid item xs={12} textAlign="center">
                  <Typography variant="h3" gutterBottom>
                    {label}
                  </Typography>
                </Grid>
              )}
              <Grid item xs={12}>
                <Container maxWidth="lg">
                  {events &&
                    events.length > 0 &&
                    events.map((event, index) => {
                      const eventStreams =
                        affiliateCodes[affiliate]?.eventStreams?.[event.id];

                      return (
                        <Grid
                          key={index}
                          item
                          xs={12}
                          sx={{ p: 2 }}
                          textAlign="center"
                        >
                          <Typography variant="h3" gutterBottom>
                            {event.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            gutterBottom
                            sx={{ textTransform: "uppercase" }}
                          >
                            {`${
                              event.gameSystem?.manufacturer
                                ? `${event.gameSystem?.manufacturer} - `
                                : ""
                            }${event.gameSystem?.name || ""}`.trim()}
                          </Typography>
                          {!event.started && (
                            //  || !event.currentRound
                            <Typography
                              textAlign="center"
                              variant="h5"
                              gutterBottom
                              sx={{ mt: 1, mb: 1 }}
                            >
                              <CountdownTimer
                                days
                                timerData={{
                                  endTime: moment(event.eventDate)
                                    .utc()
                                    .toISOString()
                                }}
                                overrideLabel="EVENT BEGINS IN"
                              />
                            </Typography>
                          )}
                          <Grid container justifyContent="center">
                            <Grid item xs={12} sm={6} md={3} sx={{ p: 1 }}>
                              <GridBox
                                title="Roster / Army Lists"
                                link={`/event/${event.id}?active_tab=roster`}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} sx={{ p: 1 }}>
                              <GridBox
                                title="Pairings"
                                link={`/event/${event.id}?active_tab=pairings`}
                                disabled={!event.currentRound}
                              />
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} sx={{ p: 1 }}>
                              <GridBox
                                title="Placings"
                                link={`/event/${event.id}?active_tab=placings`}
                                disabled={
                                  !event.currentRound || event.hidePlacings
                                }
                              />
                            </Grid>
                            {eventStreams && (
                              <Grid item xs={12} sm={6} md={3} sx={{ p: 1 }}>
                                <SocialsModal
                                  event={event}
                                  eventStreams={eventStreams}
                                />
                              </Grid>
                            )}
                          </Grid>
                        </Grid>
                      );
                    })}
                </Container>
              </Grid>

              {!authContext?.authState?.identity?.subscriber && (
                <Grid item xs={12}>
                  <Subscription
                    affiliate={affiliate}
                    hideLabels
                    hideCircuitSuite
                    containerSX={{
                      pt: 0,
                      pb: 0
                    }}
                    couponCode={
                      affiliate === "TACOMA25"
                        ? {
                            code: "TACOMA25",
                            discount: { percentage: 0.2, onceOff: true },
                            frequencies: { Yearly: true }
                          }
                        : affiliate === "wtc2023"
                          ? {
                              code: "WTC2023",
                              discount: { percentage: 0.2, onceOff: true },
                              frequencies: { Yearly: true }
                            }
                          : affiliate === "tabletoptitans"
                            ? {
                                code: "TABLETOPTITANS",
                                discount: { percentage: 0.2, onceOff: true },
                                frequencies: { Yearly: true }
                              }
                            : affiliate === "titans"
                              ? {
                                  code: "TITANS",
                                  discount: { percentage: 0.2, onceOff: true },
                                  frequencies: { Yearly: true }
                                }
                              : null
                    }
                  />
                </Grid>
              )}
            </Grid>
          </Container>

          {(affiliate === "TACOMA25" ||
            affiliate === "lvo2023" ||
            affiliate === "tabletoptitans") && (
            <Modal
              disableAutoFocus
              open={open}
              onClose={() => {
                setOpen(false);
              }}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500
              }}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: ["95vw", "85vw", 600],
                  maxHeight: "95vh",

                  bgcolor: "background.paper",
                  border: "1px solid rgba(0, 0, 0, 0.12)",
                  borderColor: "divider",
                  borderRadius: 1,
                  boxShadow: 24,

                  p: 4
                }}
              >
                <IconButton
                  aria-label="cancel"
                  color="error"
                  sx={{ position: "absolute", top: "4px", right: "4px" }}
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  <BCPXmark />
                </IconButton>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography variant="h4" paragraph>
                      {`Want to gain access to expanded event and list search, your complete event history, and every submitted list, for any event?`}
                    </Typography>
                    <Typography variant="h4" gutterBottom>
                      {affiliate === "TACOMA25" &&
                      !authContext?.authState?.identity?.hasMyWarhammer
                        ? "Link your My Warhammer account and "
                        : ""}
                      Subscribe{" "}
                      {expiry ? `before the ${expiry.format("Do MMM")}` : ""}{" "}
                      and receive $10 off your yearly BCP Subscription using
                      coupon code{" "}
                      <span style={{ fontWeight: "700" }}>
                        {affiliate.toUpperCase()}
                      </span>
                    </Typography>
                  </Grid>
                  <Grid item xs={12} textAlign="center">
                    <Button
                      variant="contained"
                      color="success"
                      href={`/subscription/new?affiliate=${affiliate}&priceId=price_1KlOYVKSvDrUcAmjVhaZQcLZ&productId=${globalVars?.pricing?.subscriptions?.playerSub}&coupon=${affiliate}`}
                      target="_blank"
                      onClick={() => setOpen(false)}
                      disabled={authContext?.authState?.identity?.subscriber}
                    >
                      Subscribe Now
                    </Button>
                  </Grid>
                  <Grid item xs={12} textAlign="center">
                    <Typography variant="caption">
                      {`(New subscribers only.)`}
                    </Typography>
                  </Grid>
                </Grid>
              </Box>
            </Modal>
          )}
        </Box>
      )}
    </>
  );
}

const GridBox = (props) => {
  const { link, onClick, title, subtitle, disabled } = props;
  return (
    <ButtonBase
      onClick={onClick}
      href={link}
      target={link ? "_blank" : null}
      disabled={disabled}
      sx={{
        width: "100%",
        height: ["60px", "150px"],

        p: 1,
        textAlign: "center",
        border: "1px solid rgba(0, 0, 0, 0.12)",
        borderColor: "divider",

        borderRadius: 1,
        boxShadow: 1,
        backgroundColor: "background.secondary",

        "&:hover": {
          backgroundColor: "rgb(46 55 77 / 24%);"
        }
      }}
    >
      <Grid container>
        <Grid item xs={12}>
          <Typography variant="h3" gutterBottom>
            {title}
          </Typography>
        </Grid>
        {subtitle && (
          <Grid item xs={12}>
            <Typography
              variant="caption"
              gutterBottom
              sx={{ textTransform: "uppercase" }}
            >
              {subtitle}
            </Typography>
          </Grid>
        )}
      </Grid>
    </ButtonBase>
  );
};

const SocialsModal = (props) => {
  const { eventStreams } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <GridBox title="Stream Live" onClick={() => setOpen(true)} />

      <Modal
        disableAutoFocus
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: ["95vw", "85vw", 600],
            maxHeight: "95vh",

            bgcolor: "background.paper",
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderColor: "divider",
            borderRadius: 1,
            boxShadow: 24,

            p: 4
          }}
        >
          <IconButton
            aria-label="cancel"
            color="error"
            sx={{ position: "absolute", top: "4px", right: "4px" }}
            onClick={() => {
              setOpen(false);
            }}
          >
            <BCPXmark />
          </IconButton>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h3" paragraph>
                Stream Live
              </Typography>
            </Grid>
            {eventStreams?.length &&
              eventStreams.map((eventStream) => (
                <Grid key={eventStream.url} item xs={12}>
                  <Button
                    href={eventStream.url}
                    target="_blank"
                    variant="outlined"
                    fullWidth
                  >
                    {eventStream.label}
                  </Button>
                </Grid>
              ))}
          </Grid>
        </Box>
      </Modal>
    </>
  );
};
